export const UI_LOCAL_STORAGE = {
  automaticallyOpen: 'ui.automaticallyOpen',
};

export const URL_PARAMS = {
  gamiphyOpen: 'gamiphy_open',
  gamiphyTab: 'gamiphy_tab',
  code: 'code',
  userId: 'userId',
};
